import React from "react";
import {
  Typography,
  Form,
  Input,
  InputNumber,
  Button,
  Row,
  Col,
  DatePicker,
  Select,
  message,
  Space
} from "antd";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { getNames } from "country-list";

const { Title } = Typography;
const { Option } = Select;

function AddProject() {

const [form] = Form.useForm();
const navigate = useNavigate();
const countries = getNames();

const saveProject = async (values) => {

try {

const startDate = values.startDate.format("YYYY-MM-DD");

const endDate = dayjs(startDate)
.add(values.duration, "day")
.format("YYYY-MM-DD");

const newProject = {
projectName: values.projectName,
client: values.client,
country: values.country,
projectLead: values.projectLead,
teamMembers: values.teamMembers,
tasks: values.tasks,
summary: values.summary,
startDate,
endDate,
sprintStart: "Not Started",
duration: values.duration,
rewardPoints: values.rewardPoints,
status: "Not Started",
};

const token = localStorage.getItem("access-token");

await fetch("https://rhrmapi.up2dateinc.com/api/projects", {
method: "POST",
headers: {
"Content-Type": "application/json",
Authorization: `Bearer ${token}`,
},
body: JSON.stringify(newProject),
});


message.success("Project Created Successfully");

navigate("/admin/projects");

} catch (error) {

message.error("Failed to create project");

}

};

return (
<div>

<Title level={3}>Create Project</Title>

<Form
layout="vertical"
form={form}
onFinish={saveProject}
style={{ maxWidth: 900 }}
>

<Row gutter={16}>

<Col span={12}>
<Form.Item
label="Project Name"
name="projectName"
rules={[{ required: true }]}
>
<Input placeholder="Project Name" />
</Form.Item>
</Col>

{/* CLIENT + ADD CLIENT BUTTON */}

<Col span={12}>
<Form.Item label="Client">

<Space style={{ width: "100%" }}>

<Form.Item
name="client"
rules={[{ required: true }]}
style={{ flex: 1, marginBottom: 0 }}
>
<Input placeholder="Client Name or Email" />
</Form.Item>

<Button
type="dashed"
onClick={() => navigate("/admin/clients")}
>
+ Add Client
</Button>

</Space>

</Form.Item>
</Col>

{/* COUNTRY */}

<Col span={12}>
<Form.Item
label="Country"
name="country"
rules={[{ required: true }]}
>
<Select placeholder="Select Country" showSearch>

{countries.map((country) => (
<Option key={country} value={country}>
{country}
</Option>
))}

</Select>
</Form.Item>
</Col>

{/* PROJECT LEAD */}

<Col span={12}>
<Form.Item
label="Project Lead"
name="projectLead"
rules={[{ required: true }]}
>
<Input placeholder="Project Lead" />
</Form.Item>
</Col>

{/* TEAM MEMBERS */}

<Col span={12}>
<Form.Item
label="Team Members"
name="teamMembers"
>
<Input placeholder="Team Members" />
</Form.Item>
</Col>

{/* TASKS */}

<Col span={12}>
<Form.Item
label="Approximate Tasks"
name="tasks"
rules={[{ required: true }]}
>
<InputNumber
min={1}
style={{ width: "100%" }}
placeholder="Approximate Tasks"
/>
</Form.Item>
</Col>

{/* DURATION */}

<Col span={12}>
<Form.Item
label="Project Duration (Days)"
name="duration"
rules={[{ required: true }]}
>
<InputNumber
min={1}
style={{ width: "100%" }}
placeholder="In Days"
/>
</Form.Item>
</Col>

{/* SUMMARY */}

<Col span={24}>
<Form.Item
label="Summary"
name="summary"
rules={[{ required: true }]}
>
<Input.TextArea rows={3} placeholder="Summary" />
</Form.Item>
</Col>

{/* START DATE */}

<Col span={12}>
<Form.Item
label="Start Date"
name="startDate"
rules={[{ required: true }]}
>
<DatePicker style={{ width: "100%" }} />
</Form.Item>
</Col>

{/* REWARD POINTS */}

<Col span={12}>
<Form.Item
label="Reward Points"
name="rewardPoints"
rules={[{ required: true }]}
>
<InputNumber
min={0}
style={{ width: "100%" }}
placeholder="Reward Points"
/>
</Form.Item>
</Col>

</Row>

<Button type="primary" htmlType="submit">
Create Project
</Button>

</Form>

</div>
);
}

export default AddProject;